<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${stockMovement.code}` }} - {{ $t("COMMON.LOGS") }}
    </h3>

    <log-list-table :filterSubject="stockMovement" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "stock-movement-view-logs",

  components: { LogListTable },

  props: ["stockMovement"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
